import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { DELIVERY } from '../../util/types';

import deliveryIcon from '../../assets/icons/deliveryIcon.png';
import css from './DeliveryBadge.css';

const checkListingIsDelivery = (deliveryType) => {
  return deliveryType && deliveryType.includes(DELIVERY);
}

const DeliveryBadge = ({
  rootClassName,
  className,
  deliveryType
}) => {
  const isDeliveryListing = checkListingIsDelivery(deliveryType);

  const classes = classNames(rootClassName || css.root, className);

  return isDeliveryListing ? (
    <div className={classes}>
      <img src={deliveryIcon} alt="delivery"/>
    </div>
  ) : null;
};

DeliveryBadge.propTypes = {
  rootClassName: string,
  className: string,
};

export default DeliveryBadge;